import { useState } from "react"

export const ToolStates = () => {
    const [prefetch, setPrefetch] = useState(false)
    const [__SESSION, setSession] = useState({ainfo: null, pinfo: null})
    const [userId, setUserId] = useState()
    const [companyInfo, setCompanyInfo] = useState([])
    const [toolUsers, setToolUsers] = useState([])

    //PRE LOAD FOR SWITCHING TOOLS
    const [preload, setPreload] = useState({loader:false, logo:''}) 

    //GLOBAL STATE
    const [globalLoader, setGlobalLoader] = useState(true)

    const [toolOwned, setToolOwned] = useState([])

    const [validateAccount, setValidateAccount] = useState({data:'', count:0})

    const [profession, setProfession] = useState([])

    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [barangays, setBarangays] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [department, setDepartment] = useState([]);
    const [position, setPosition] = useState([]);
    const [openGMModal, setOpenGMModal] = useState(false)
    const [openPModal, setOpenPModal ] = useState(false)
    
    const [toolShuffle, setToolShuffle] = useState([]);

    //PROFESSIONAL STATE
    const [pData, setPData] = useState({first_name: '' , middle_name:'', last_name: '', suffix: '', prc_id_expiry_date:'', profession:'', prc_license:null });
    const [invalidNo, setInvalidNo] = useState(false);
    const [validDate, setValidDate] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const [errors, setErrors] = useState({ 
        profession: false,
        prc_license_num: false,
        prc_expiry_date: false,
    });
    

    return {
        toolShuffle: {data: toolShuffle, set: setToolShuffle},

        prefetch: {data: prefetch, set: setPrefetch},
        __SESSION: {data: __SESSION, set: setSession},
        userId: {data: userId, set: setUserId},
        toolUsers: {data: toolUsers, set: setToolUsers},

        //PROFESSIONAL STATE
        pData: {data: pData, set: setPData},
        errors: {data: errors, set: setErrors},
        isLoader: {data: isLoader, set: setIsLoader},
        invalidNo:{ data: invalidNo, set: setInvalidNo},
        validDate:{ data: validDate, set: setValidDate},

        //PRE LOAD FOR SWITCHING TOOLS
        preload: {data: preload, set: setPreload},

        //COMPANY INFO
        cinfo: {data: companyInfo, set: setCompanyInfo},
        employee: {data: employee, set: setEmployee},
        department: {data: department, set: setDepartment},
        position: {data: position, set: setPosition},

        //ADDRESS INFO
        provinces: {data: provinces, set: setProvinces},
        cities: {data: cities, set: setCities},
        barangays: {data: barangays, set: setBarangays},

        //GLOBAL STATE
        globalLoader: {data: globalLoader, set: setGlobalLoader},
        toolOwned: {data: toolOwned, set: setToolOwned},
        profession: {data: profession, set: setProfession},
        openGMModal: {data: openGMModal, set: setOpenGMModal},
        openPModal: {data: openPModal, set: setOpenPModal},

        validateAccount: {data: validateAccount, set: setValidateAccount}
    }
}